// Свидетельство выполнения (004: FR-001 – FR-026; ADR-0005). Узел решений задаёт модели один
// вопрос о пункте; вероятность хранится у пункта версии, итог «закрыто» считается при чтении
// по порогу из настроек — смена порога не вызывает модель (FR-018).
import { z } from '../kernel/zod.ts';

/** Вопрос узла решений о свидетельстве выполнения и его версия: растёт при любой правке текста. */
export const EVIDENCE_QUESTION_ID = 'completion_evidence';
export const EVIDENCE_QUESTION_VERSION = 'v2';

/**
 * Вопросы «выбор» мастера подключения протокола и их версии (010, research, Р4; contracts/api.md
 * 010, «Узел решений»): растут при любой правке текста инструкции — с замером на эталоне (SC-010).
 */
export const PROTOCOL_HEADER_ROW_QUESTION = 'protocol_header_row';
export const PROTOCOL_COLUMN_ROLE_QUESTION = 'protocol_column_role';
export const protocolQuestionVersions = {
  [PROTOCOL_HEADER_ROW_QUESTION]: 'v1',
  [PROTOCOL_COLUMN_ROLE_QUESTION]: 'v1',
} as const;

/** Решение ИИ о пункте: вероятность свидетельства и модель из ответа (FR-008, FR-016). */
export const EvidenceSchema = z.object({
  probability: z.number().min(0).max(1),
  model: z.string(),
  /** Запись журнала решений ИИ; null — решение взято из файла кэша показа 0. */
  decisionId: z.uuid().nullable(),
});
export type Evidence = z.infer<typeof EvidenceSchema>;

/**
 * Почему модель не ответила (FR-020, FR-021). limit — месячный лимит вопросов о виде
 * упоминания исчерпан или вопрос выключен лимитом 0 (005-3, FR-018); модель не вызывалась.
 */
export const evidenceRefusals = [
  'no_key',
  'timeout',
  'refused',
  'bad_shape',
  'disabled',
  'limit',
] as const;
export type EvidenceRefusal = (typeof evidenceRefusals)[number];
export const EvidenceRefusalSchema = z.enum(evidenceRefusals);

/** Раздел `recognition` настроек установки (FR-004, FR-007). Ключ — только окружение KP_JEV_KEY. */
export const RecognitionSettingsSchema = z.object({
  enabled: z.boolean().default(true),
  provider: z.literal('jev').default('jev'),
  /** Модель закреплена: смена — выкат вместе с замером на эталоне (ADR-0005). */
  model: z.string().default('jev-1.13.0'),
  url: z.url().default('https://api.typesafe.ai/v1/systemone'),
  timeoutMs: z.number().int().min(500).max(30_000).default(3000),
  /** Одновременных вызовов в задаче свидетельства. */
  concurrency: z.number().int().min(1).max(16).default(4),
});
export type RecognitionSettings = z.infer<typeof RecognitionSettingsSchema>;
